'use strict';

import React, {Component} from 'react';
import {observer} from "mobx-react";

import announcerStore from './AnnouncerStore';

class Announcer extends Component {
    constructor(props) {
        super(props);
        this.props = props;
        this.store = announcerStore;
    }

    // Check to see if a message for a11y exists
    hasMessage() {
        return (this.store.messageMap.text !== null && this.store.messageMap.text !== "");
    }

    // a visually hidden element with aria-live capability to provide messaging
    render() {
        return (
            <div id="announcer"
                 role="log"
                 aria-live={this.hasMessage() ? this.store.messageMap.level : "off"}
                 aria-atomic="true"
                 aria-relevant="text"
                 className="sr-only">
                {this.store.messageMap.text}
            </div>
        );
    }
}

export default observer(Announcer);
